import React, { Component } from 'react';
import routes from '../constants/routes';
import swal from 'sweetalert';
import constants from "../constants/constants";
import Cookies from "js-cookie";

class PaymentCallback extends Component {

    state = {
        isProcessing: true,
        paymentData: null
    }

    componentDidMount() {
        this.handlePaymentCallback();
    }

    handlePaymentCallback = () => {
        // Get data from URL parameters (passed by server-side callback handler)
        const urlParams = new URLSearchParams(window.location.search);

        // Extract payment data from URL parameters set by server
        const statusCode = urlParams.get('status_code');
        const orderId = urlParams.get('order_id');
        const orderReference = urlParams.get('order_refference_number');
        const transactionAmount = urlParams.get('transaction_amount');
        const requestedAmount = urlParams.get('requested_amount');
        const signature = urlParams.get('signature');
        const payment = urlParams.get('payment');

        // Also check sessionStorage for data (alternative approach)
        let paymentData = null;

        if (statusCode && orderId) {
            // Data from URL parameters
            paymentData = {
                statusCode,
                orderId,
                orderReference,
                transactionAmount,
                requestedAmount,
                signature,
                payment
            };
        } else {
            // Try to get from sessionStorage (set by server-side redirect)
            const storedData = sessionStorage.getItem('webxpay_callback_data');
            if (storedData) {
                try {
                    paymentData = JSON.parse(storedData);
                    sessionStorage.removeItem('webxpay_callback_data'); // Clear after use
                } catch (error) {
                    console.error('Error parsing stored payment data:', error);
                }
            }
        }

        if (paymentData) {
            console.log('Payment Callback Data:', paymentData);
            this.setState({ paymentData });
            this.processPaymentStatus(
                paymentData.statusCode || paymentData.status_code,
                paymentData.orderId || paymentData.order_id,
                paymentData.orderReference || paymentData.order_refference_number,
                paymentData.transactionAmount || paymentData.transaction_amount
            );
        } else {
            // No payment data found
            setTimeout(() => {
                this.handleFailedPayment('NO_DATA', 'UNKNOWN');
            }, 3000);
        }
    }

    processPaymentStatus = (statusCode, orderId, orderReference, transactionAmount) => {
        this.setState({ isProcessing: false });

        // Convert to string for consistent comparison
        const status = String(statusCode);

        if (status === '0' || status === '00') {
            // Payment successful (Code 0 = Transaction Approved)
            this.handleSuccessfulPayment(orderId, orderReference, transactionAmount);
        } else {
            // Payment failed (Code 15 = Transaction Declined, others = various failures)
            this.handleFailedPayment(status, orderId);
        }
    }

    handleSuccessfulPayment = async (orderId, orderReference, transactionAmount) => {
        let isCookie = Cookies.get(constants.ACCESS_TOKEN)
        let prevRoutePath = sessionStorage.getItem('payment_route_path');
        if (prevRoutePath) sessionStorage.removeItem('payment_route_path');
        // Show success message
        swal({
            title: "Payment Successful!",
            text: `Your package has been renewed successfully.\n\nOrder ID: ${orderId}\nReference: ${orderReference}\nAmount: LKR ${transactionAmount}`,
            icon: "success",
            closeOnClickOutside: false,
            buttons: {
                confirm: { text: "Continue", value: "continue", className: "swalSuccess" }
            }
        }).then((value) => {
            if (value === "continue") {
                window.location.href = isCookie !== undefined ? routes.myProfile : routes.login;
            }
        });

    }

    handleFailedPayment = (statusCode, orderId) => {
        let isCookie = Cookies.get(constants.ACCESS_TOKEN)
        let prevRoutePath = sessionStorage.getItem('payment_route_path');
        if (prevRoutePath) sessionStorage.removeItem('payment_route_path');
        let errorMessage = this.getErrorMessage(statusCode);

        swal({
            title: "Payment Failed",
            text: `Unfortunately, your payment has failed.\n\nError Code: ${statusCode}\nOrder ID: ${orderId}\n\n${errorMessage}\n\nIf you require assistance, please contact us on 0114326791`,
            icon: "error",
            closeOnClickOutside: false,
            buttons: {
                contact: { text: "Contact Support", value: "contact", className: "swalDanger" },
                retry: { text: "Try Again", value: "retry", className: "swalSuccess" }
            }
        }).then((value) => {
            switch (value) {
                case "contact":
                    window.location.href = routes.contact;
                    break;
                case "retry":
                    window.location.href = isCookie !== undefined ? routes.myProfile : routes.login;

                    break;
                default:
                    window.location.href = isCookie !== undefined ? routes.myProfile : routes.login;

                    break;
            }
        });
    }

    getErrorMessage = (statusCode) => {
        const errorMessages = {
            '0': 'Transaction Approved',
            '00': 'Transaction Approved',
            '15': 'Transaction Declined - The transaction was unsuccessful',
        };

        return errorMessages[statusCode] || 'Unknown error occurred';
    }

    render() {
        const { isProcessing, paymentData } = this.state;

        if (isProcessing) {
            return (
                <div className="container mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-6 text-center">
                            <div className="card">
                                <div className="card-body">
                                    <div className="spinner-border text-primary mb-3" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <h5 className="card-title">Processing Payment...</h5>
                                    <p className="card-text">
                                        Please wait while we verify your payment details.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Payment Processing Complete</h5>
                                {paymentData && (
                                    <div>
                                        <p><strong>Status:</strong> {((paymentData.statusCode === '0' || paymentData.statusCode === '00') || (paymentData.status_code === '0' || paymentData.status_code === '00')) ? 'Success' : 'Failed'}</p>
                                        <p><strong>Order ID:</strong> {paymentData.orderId || paymentData.order_id}</p>
                                        <p><strong>Reference:</strong> {paymentData.orderReference || paymentData.order_refference_number}</p>
                                        <p><strong>Amount:</strong> LKR {paymentData.transactionAmount || paymentData.transaction_amount}</p>
                                    </div>
                                )}
                                {/* <p className="text-muted">You will be redirected shortly...</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentCallback; 